// His `shrink`: a phone photo made a JPEG of at most 1600 px on its longest side before it is sent,
// so it goes up quickly from a client's flat.
export async function shrinkImage(file: File, max = 1600): Promise<File> {
  const src = await createImageBitmap(file);
  const scale = Math.min(1, max / Math.max(src.width, src.height));
  const canvas = Object.assign(document.createElement("canvas"), { width: Math.round(src.width * scale), height: Math.round(src.height * scale) });
  canvas.getContext("2d")!.drawImage(src, 0, 0, canvas.width, canvas.height);
  src.close();
  const blob = await new Promise<Blob | null>((res) => canvas.toBlob(res, "image/jpeg", 0.85));
  return blob ? new File([blob], file.name.replace(/\.\w+$/, "") + ".jpg", { type: "image/jpeg" }) : file;
}
